<section class="investment-regimes">
  <div class="row gafi-tabs justify-content-end zer-mar">
    <div class="col-lg-6 col-12 right_section ">
      <h3 class="txt--white uppercase">الأنظمة الاستثمارية</h3>
      <a href="../../../assets/backPerfect.png" title="مشاهدة الكل" class="txt--white font-xsl">
        مشاهدة كل الأنظمة لاستثمارية
        <span class="icon-plus"></span>
      </a>

      <div class="row h-100 mr-t90">
        <div class="col-md-3 col-4 zero-padd" *ngFor="let regime of regimes; let i = index"
          (click)="selectRegime(regime)">
          <a [title]="regime.title" class="tab-link text-center" [class.active]="selectedRegime.id === regime.id">
            <img [src]="regime.img" [title]="regime.title" class="item_img" />
          </a>
        </div>
      </div>
    </div>

    <!-- Left Section -->
    <div class="col-lg-6 hide-md item_card">
      <div class="row">
        <div class="col-10">
          <p class="regim_title">{{ selectedRegime.title }}</p>
          <p class="regime_desc">{{ selectedRegime.desc }}</p>
          <a [href]="selectedRegime.link" class="btn btn-gafi-green" target="_blank">إقرأ المزيد</a>
        </div>
      </div>
    </div>
  </div>
</section>